import type { campanhas as pt } from '../pt-BR/campanhas';
import type { Traducao } from '../Traducao';

export const campanhas = {
  titulo: 'Campaigns',
  nova: 'New campaign',
  colunas: {
    nome: 'Name',
    periodo: 'Period',
    fase: 'Stage',
    progresso: 'Progress',
    acoes: 'Actions',
  },
  /** Selo da campanha ativa na lista (spec 29 R14). */
  ativaSelo: 'Active',
  estados: {
    aberta: 'Open',
    agendada: 'Scheduled',
    encerrada: 'Closed',
    inativa: 'Inactive',
  },
  form: {
    nome: 'Name',
    inicio: 'Start',
    fim: 'End',
    janela: 'Planned shipping window',
    entregaPrevista: 'Estimated gift delivery',
    entregaPrevistaHint:
      'Enter an estimate of the dates between which the professional will receive the gift. It is shown to them on the form.',
    entregaInicio: 'From',
    entregaFim: 'To',
    dataInvalida: 'Invalid date.',
    calendario: 'Pick {{campo}} on the calendar',
  },
  acoes: {
    abrir: 'Open',
    ver: 'View',
    editar: 'Edit',
    carregarAxiis: 'Load from Axiis',
    carregarDeNovo: 'Load again',
    revisarTexto: 'Review message',
    editarTexto: 'Invitation message',
    abrirCampanha: 'Open campaign',
    desativarEAbrir: 'Deactivate {{outra}} and open this one',
    enviarConvites: 'Send invitations',
    enviarNaoRecebidos_one: 'Send to 1 person not yet invited',
    enviarNaoRecebidos_other: 'Send to the {{count}} not yet invited',
    lembrar_one: "Remind the person who hasn't answered",
    lembrar_other: "Remind the {{count}} who haven't answered",
    baixarPlanilha: 'Download shipping sheet',
    pausar: 'Pause',
    reabrir: 'Reopen',
    fechar: 'Close campaign',
    editarDatas: 'Edit dates',
  },
  confirmar: {
    desativar: 'Pause {{nome}}? The form stops accepting responses. Nothing is deleted.',
    fechar: 'Close {{nome}}? The campaign goes offline and another one can be opened.',
  },
  checklist: {
    rotulo: 'Campaign setup',
    concluido: 'Done',
    pendente: 'Pending',
    participantes: 'Recipients',
    ninguem: 'No one in the campaign yet',
    texto: 'Invitation message',
    naoRevisado: 'Not reviewed yet',
    editarTexto: 'Edit message',
    periodo: 'Period',
    terminou: 'The period has ended',
    abrirTitulo: 'Open the campaign',
    falta: 'To open, you still need to {{itens}}.',
    faltaParticipantes: 'load the recipients',
    faltaTexto: 'review the invitation message',
    faltaPeriodo: 'fix the period',
  },
  acompanhamento: 'Follow up',
  participantes: 'Recipients',
  convite: { titulo: 'Invitation message', concluirRevisao: 'Finish review' },
  descricao: 'From {{inicio}} to {{fim}}',
  descricaoComEntrega: 'From {{inicio}} to {{fim}} · gift arrives: {{entrega}}',
  fases: {
    preparacao: 'Being prepared',
    vencida: 'Expired',
    agendada: 'Scheduled',
    aberta: 'Open',
    encerrada: 'Ended',
    pausada: 'Paused',
    fechada: 'Closed',
  },
  resumoAbrir_one: '{{count}} person · {{idiomas}} · from {{inicio}} to {{fim}}',
  resumoAbrir_other: '{{count}} people · {{idiomas}} · from {{inicio}} to {{fim}}',
  abrir: {
    pessoas_one: '{{count}} person · {{idiomas}}',
    pessoas_other: '{{count}} people · {{idiomas}}',
    personalizado: 'custom',
    padrao: 'default',
    oQueAcontece:
      'Once open, the link starts accepting answers. No e-mail goes out on its own: you send the invitations in Follow up.',
    oQueAconteceAgendada:
      'Once open, the link accepts answers from {{inicio}}. No e-mail goes out on its own: you send the invitations in Follow up.',
  },
  vazio: 'No campaigns created.',
  dialogo: { abrir: 'Open {{nome}}', outraAtiva: 'Currently open: {{outra}}.' },
  funil: {
    naCampanha: 'In the campaign',
    convidados: 'Invited',
    acessaram: 'Visited',
    responderam: 'Answered',
    naoConvidados_one: '{{count}} not invited',
    naoConvidados_other: '{{count}} not invited',
    falhas: '{{count}} failed',
    naoAcessaram_one: "{{count}} didn't visit",
    naoAcessaram_other: "{{count}} didn't visit",
    pararamNoMeio_one: "{{count}} visited and didn't answer",
    pararamNoMeio_other: "{{count}} visited and didn't answer",
    doTotal: '{{p}}% of total',
  },
  filtros: {
    busca: 'Search by name',
    todasFases: 'All stages',
    periodo: 'Period',
    limpar: 'Clear all',
  },
  semResultado: 'No campaigns match these filters.',
} as const satisfies Traducao<typeof pt>;
